
// export default MapsCamions;
import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getlocationCamion } from "../../../api/camion";

// Icônes camions selon le status
const truckIcons = {
  active: new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/743/743920.png", // vert/bleu pour actif
    iconSize: [34, 34],
    iconAnchor: [17, 34],
    popupAnchor: [0, -30],
  }),
  inactive: new L.Icon({
    iconUrl: "https://static.vecteezy.com/system/resources/previews/048/263/421/non_2x/inactive-icon-editable-stroke-linear-style-sign-for-use-web-design-logo-symbol-illustration-free-vector.jpg", // rouge pour inactif
    iconSize: [34, 34],
    iconAnchor: [17, 34],
    popupAnchor: [0, -30],
  }),
};

// Ajuste automatiquement le zoom sur tous les camions
function FitBounds({ trucks }) {
  const map = useMap();
  useEffect(() => {
    if (!trucks || trucks.length === 0) return;
    const bounds = L.latLngBounds(
      trucks.map((t) => [parseFloat(t.lat), parseFloat(t.lng)])
    );
    map.fitBounds(bounds, { padding: [180, 180] });
  }, [trucks, map]);
  return null;
}

// Marqueur camion
function TruckMarker({ truck }) {
  const markerRef = useRef(null);

  useEffect(() => {
    if (markerRef.current) markerRef.current.openPopup();
  }, []);

  const icon = truck.status === "1" ? truckIcons.active : truckIcons.inactive;

  return (
    <Marker
      position={[parseFloat(truck.lat), parseFloat(truck.lng)]}
      icon={icon}
      ref={markerRef}
    >
      <Popup autoClose={false} closeOnClick={false}>
        🚚 <strong>{truck.immatriculation}</strong>
        <br />
        IMEI: {truck.imei}
        <br />
        Status: {truck.status === "1" ? "Actif" : "Inactif"}
      </Popup>
    </Marker>
  );
}

// --- Notification simple ---
const Toast = ({ message }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        backgroundColor: "#333",
        color: "#fff",
        padding: "10px 16px",
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        fontSize: 14,
        zIndex: 9999,
        opacity: 0.9,
        transition: "opacity 0.3s",
      }}
    >
      {message}
    </div>
  );
};

// Composant principal
const MapsCamions = () => {
  const [trucks, setTrucks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null); // notification message

  // Fonction de fetch
  const fetchLocationCamion = async (showToast = true) => {
    try {
      const res = await getlocationCamion();
      setTrucks(res.data);
      setLoading(false);

      if (showToast) {
        setToast("Positions camions mises à jour ✅");
        setTimeout(() => setToast(null), 2000); // disparaît après 2s
      }
    } catch (err) {
      console.error("Erreur de récupération des positions camions :", err);
      if (showToast) {
        setToast("Erreur lors du rafraîchissement ❌");
        setTimeout(() => setToast(null), 2500);
      }
    }
  };

  // Initialisation + auto-refresh
  useEffect(() => {
    fetchLocationCamion(false); // premier chargement sans toast

    const interval = setInterval(() => {
      fetchLocationCamion(); // mise à jour toutes les 15 secondes
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  if (loading)
    return (
      <p style={{ textAlign: "center", marginTop: 20 }}>
        Chargement des camions...
      </p>
    );

  if (!trucks || trucks.length === 0)
    return (
      <p style={{ textAlign: "center", marginTop: 20 }}>
        Aucun camion à afficher
      </p>
    );

  // Calcul du centre initial
  const avgLat =
    trucks.reduce((a, t) => a + parseFloat(t.lat), 0) / trucks.length;
  const avgLng =
    trucks.reduce((a, t) => a + parseFloat(t.lng), 0) / trucks.length;

  return (
    <div style={{ height: "100vh", width: "100%", position: "relative" }}>
      {toast && <Toast message={toast} />}

      <MapContainer
        center={[avgLat, avgLng]}
        zoom={7}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          // attribution='&copy; OpenStreetMap contributors'
          // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap France | Contributeurs OSM'
          url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
          // attribution='&copy; OpenStreetMap contributors & CartoDB'
          // url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png"
          // attribution='&copy; Stadia Maps, &copy; OpenMapTiles &copy; OpenStreetMap contributors'
          // url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
          // attribution='Tiles &copy; Esri — Source: Esri, FAO, NOAA'
          // url="https://services.arcgisonline.com/ArcGIS/rest/services/Demographics/World_Population_Density/MapServer/tile/{z}/{y}/{x}"
  //          attribution='Tiles &copy; Esri — Source: Esri, FAO, NOAA'
  // url="https://services.arcgisonline.com/ArcGIS/rest/services/Demographics/World_Population_Density/MapServer/tile/{z}/{y}/{x}"
  // attribution='&copy; Esri, Maxar, Earthstar Geographics, and the GIS User Community'
  // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
  //  attribution='&copy; Esri, Maxar, Earthstar Geographics, and the GIS User Community'
    // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
  // attribution='&copy; OpenStreetMap contributors'
  // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  // opacity={0.5  }
          
        />

        {trucks.map((truck) => (
          <TruckMarker key={truck.imei} truck={truck} />
        ))}

        <FitBounds trucks={trucks} />
      </MapContainer>
    </div>
  );
};

export default MapsCamions;
